import Vue from "vue";

export const mutations = {
  SET_ACTIVITY_LOGS: (state, payload) => Vue.set(state, "activityLogs", payload),
}
